<template>
    <div class="dialog">
        <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="818px" :before-close="handleClose">
            <section >
                <div class="serach">
                    <el-input prefix-icon="el-icon-search" v-model="formTool.goodsName" placeholder="请输入商品名称" clearable
                        size="small" style="width: 200px;" @change="change" />
                </div>
                <div>
                    <goodsItem :goodsList="goodsList" @chooseItem="chooseItem" class="goods-content" />
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page.sync="page.current"
                        :page-sizes="page.pageSizes" layout="total, sizes, prev, pager, next" :total="page.total">
                    </el-pagination>
                </div>
            </section> 
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="chooseGoods">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import goodsItem from "./controlSalesGoodsItem.vue";
import { queryGoodsBaseCallBackNew } from "@/api/product";
export default {
    components: {
        goodsItem
    },
    props: {
        btnType: {
            type: String,
            default: ''
        },
    },
    computed: {
        visible() {
            return this.dialogShow
        }
    },
    data() {
        return {
            showForm: false, //是否展示表单
            dialogShow: false,
            isDisabled: false,
            pageType: '',
            formTool: {
                name: ''
            },
            title: '',
            goodsList: [],
            selectItems: [],
            page: {
                total: 10,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
        }
    },
    mounted() {
        
    },
    methods: {
        init(row, type) {
            this.title = '';
            if (type == 'detail') {
                this.isDisabled = true;
                this.title = '召回商品详情'
                this.getGoods(1);
            }
          
            if (type == 'add') {
                this.isDisabled = false;
                this.title = '新增召回商品'
                this.showForm = false;
                this.getGoods(1);
            } 
            this.dialogShow = true;
            this.$forceUpdate(); 
            this.page.current = 1;
           
        },
        // 搜索
        change(e) {
            console.log(e)
            this.getGoods(1)
        },
        // 页码变化
        handleCurrentChange(e) {
            this.page.current = e;
            this.getGoods()
        },
        // 条数变化
        handleSizeChange(e) {
            this.page.size = e
            this.page.current = 1;
            this.getGoods()  
        },
        // 获取商品列表
        getGoods(current) {
            const params = {
                size: this.page.size ,
                current:current ? current: this.page.current ,
                name: this.formTool.goodsName
            };
            queryGoodsBaseCallBackNew(params).then((res) => { 
                if (res) {
                    this.goodsList = res.data.records;  
                    this.page.total = res.data.total;
                    this.$forceUpdate()
                }
            });
        },
        handleClose() {
            this.page.current = 1;
            this.dialogShow = false;
        },
        chooseItem(arr) {
            this.selectItems = arr; 
        }, 
        chooseGoods() {
            if (!this.selectItems.length) {
                this.$message.warning('请选择推广商品')
                return
            }
            this.dialogShow = false;
            this.$emit('didSelectItem', this.selectItems[0])
        }
    }
}
</script>
<style lang="scss">
.btnBox {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.serach {
    margin-bottom: 10px;
}

.goods-content {
 
    overflow-y: auto;
}
</style>